import React from 'react';
import {MatchEventsModuleController} from "../match-events-module.controller";
import {MatchEventsModuleProps} from "../models/match-events-module.props";
import {Compose, ComposeSettings} from "../../../../../core/components/composers/compose";
import {MatchEventModuleTabContent} from "./match-event-module.tab-content";
import {MatchEventsModuleTabs} from "./match-events-module.tabs";
import {MatchEventsModuleFooter} from "./match-events-module.footer";
import {WidgetWrapper} from "../../../../../core/components/misc/widget-wrapper/widget-wrapper";
import {MatchEventsModulePlayByPlay} from "./match-events-module.play-by-play";
import styles from "../styles/match-event.module.scss";
import classNames from "classnames";
import {MatchEventModulePlayerStatsPopup} from "./match-event-module.player-stats.popup";
import {Loader} from "../../../../../core/components/loading/loader";
import {COMPONENT_STATES, FETCHING_STATES} from "../../../../../core/consts";
import {MatchEventModulePlaceholder} from "./placeholders/match-event.module.placeholder";

export class MatchEventsModuleComponentProps extends MatchEventsModuleProps {
}

export const MatchEventsModuleComponent = ({controller, gameId, location}: MatchEventsModuleComponentProps) => {
  const {terms, state} = controller;
  const {GAME_HIGHLIGHTS} = terms;

  const titleProps = {
    title: GAME_HIGHLIGHTS,
    controller
  }

  const baseProps = {
    controller,
    location,
    gameId
  }

  const loaderProps = {
    when: state.fetchingState === FETCHING_STATES.fetching || state.componentState === COMPONENT_STATES.loading,
    Component: MatchEventModulePlaceholder,
  };

  return (
    <Loader {...loaderProps}>
      <WidgetWrapper {...titleProps}>
        <div className={classNames(styles.container)}>
          <MatchEventsModuleTabs controller={controller}/>
          <MatchEventModuleTabContent {...baseProps}/>
          <MatchEventsModuleFooter controller={controller}/>
        </div>
        <MatchEventsModulePlayByPlay {...baseProps}/>
        <MatchEventModulePlayerStatsPopup controller={controller}/>
      </WidgetWrapper>
    </Loader>
  )
}

const settings: ComposeSettings = {
  component: MatchEventsModuleComponent,
  propsType: MatchEventsModuleComponentProps,
  controllerType: MatchEventsModuleController,

  createModule: true,
  observe: true,
}

export default Compose(settings);
